import { FaMosque } from 'react-icons/fa6';
import { IoMdAdd } from 'react-icons/io';

const AddMosqueButton = ({ onClick }) => {
  return (
    <button 
      className="add-mosque-btn"
      onClick={onClick}
      aria-label="Add Mosque"
    >
      <div className="add-mosque-btn__content">
        <FaMosque className="add-mosque-btn__icon-mosque" />
        {/* <span className="dd-mosque-btn__tooltip">Add Mosque</span> */}
        {/* <IoMdAdd className="add-mosque-btn__icon-plus" /> */}
      </div>
      <div className="add-mosque-btn__tooltip" onClick={onClick}>Add Mosque</div>
    </button>
  );
};

export default AddMosqueButton; 